import { getLanguage } from '../../../utils/localization'

export const knowledgeTypes = [
  'Techniques',
  'World flavours',
  'Products',
] as const
export type KnowledgeType = (typeof knowledgeTypes)[number]

export const maybeGetKnowledgeType = (maybeKnowledgeType: string) =>
  maybeKnowledgeType == 'Techniques'
    ? 'Techniques'
    : maybeKnowledgeType == 'World flavours'
    ? 'World flavours'
    : maybeKnowledgeType == 'Products'
    ? 'Products'
    : false

export const getKnowledgeTypeSectionOfSlug = (knowledgeType: KnowledgeType) =>
  knowledgeType === 'Techniques'
    ? {
        en: 'techniques',
        nl: 'technieken',
      }
    : knowledgeType === 'World flavours'
    ? {
        en: 'world-flavours',
        nl: 'wereldsmaken',
      }
    : {
        en: 'product-knowledge',
        nl: 'warenkennis',
      }

export const getKnowledgeSlug = (knowledgeType: KnowledgeType, slug: string) =>
  getLanguage() === 'en'
    ? `/en/knowledge/${getKnowledgeTypeSectionOfSlug(knowledgeType).en}${slug
        .toLowerCase()
        .replace('%', '')}`
    : `/nl/kennis/${getKnowledgeTypeSectionOfSlug(knowledgeType).nl}${slug
        .toLowerCase()
        .replace('%', '')}`
